import { CollapsibleItem } from '@/models';
import Vue from 'vue';

export const collapseMixin = Vue.extend({
  computed: {
    collapsibleItems(): CollapsibleItem[] {
      return [];
    },
    collapsibleItemsLength(): number {
      return this.collapsibleItems.filter((item: CollapsibleItem) => item.hasOwnProperty('collapsed')).length;
    },
    visibleCollapsibleItemsLength(): number {
      return this.collapsibleItems.filter((item: CollapsibleItem) => item.collapsed).length;
    },
    isAnyItemCollapsed(): boolean {
      return this.collapsibleItemsLength === 0 || this.visibleCollapsibleItemsLength < this.collapsibleItemsLength;
    },
  },
  methods: {
    toggleAllCollapsibleItems() {
      this.collapsibleItemsLength === this.visibleCollapsibleItemsLength
      ? this.closeAllItems()
      : this.openAllItems();
    },
    closeAllItems() {
      this.collapsibleItems.forEach((_: CollapsibleItem, index: number) => {
        if (this.collapsibleItems[index].hasOwnProperty('collapsed')) {
          this.collapsibleItems[index].collapsed = false;
        }
      });
    },
    openAllItems() {
      this.collapsibleItems.forEach((_: CollapsibleItem, index: number) => {
        if (this.collapsibleItems[index].hasOwnProperty('collapsed')) {
          this.collapsibleItems[index].collapsed = true;
        }
      });
    },
  },
});
